export const CAR_DOC_TYPE_REG_CERT = 1;
export const CAR_DOC_TYPE_PTS = 2;
export const CAR_DOC_TYPE_UTIL_CERT = 3;
export const CAR_DOC_TYPE_CONFORMITY_CERT = 4;
export const CAR_DOC_TYPE_CUSTOMS_CERT = 5;
export const CAR_DOC_TYPE_PURCHASE_CONTRACT = 6;
export const CAR_DOC_TYPE_INSPECTION_ACT = 7;
export const CAR_DOC_TYPE_PHOTOS = 8;
export const CAR_DOC_TYPE_CONSIGNMENT_CONTRACT = 9;

export const CAR_DOCUMENT_TYPE_MAP = {
  [CAR_DOC_TYPE_REG_CERT]: 'Ð¡Ð²Ð¸Ð´ÐµÑÐµÐ»ÑÑÑÐ²Ð¾ Ð¾ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸ Ð¢Ð¡',
  [CAR_DOC_TYPE_PTS]: 'ÐÐ¢Ð¡',
  [CAR_DOC_TYPE_UTIL_CERT]: 'Ð¡ÐµÑÑÐ¸ÑÐ¸ÐºÐ°Ñ Ð¾Ð± Ð¾Ð¿Ð»Ð°ÑÐµ ÑÑÐ¸Ð»Ð¸Ð·Ð°ÑÐ¸Ð¾Ð½Ð½Ð¾Ð³Ð¾ ÑÐ±Ð¾ÑÐ°',
  [CAR_DOC_TYPE_CONFORMITY_CERT]: 'Ð¡ÐµÑÑÐ¸ÑÐ¸ÐºÐ°Ñ ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ñ',
  [CAR_DOC_TYPE_CUSTOMS_CERT]: 'Ð¡ÐµÑÑÐ¸ÑÐ¸ÐºÐ°Ñ Ð¾ Ð¿ÑÐ¾ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ð¸ ÑÐ°Ð¼Ð¾Ð¶ÐµÐ½Ð½Ð¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐ¸',
  [CAR_DOC_TYPE_PURCHASE_CONTRACT]: 'ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð²ÑÐºÑÐ¿Ð°',
  [CAR_DOC_TYPE_INSPECTION_ACT]: 'ÐÐºÑ Ð¿ÑÐ¸ÑÐ¼ÐºÐ¸/Ð¾ÑÐ¼Ð¾ÑÑÐ° Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
  [CAR_DOC_TYPE_PHOTOS]: 'Ð¤Ð¾ÑÐ¾Ð³ÑÐ°ÑÐ¸Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
  [CAR_DOC_TYPE_CONSIGNMENT_CONTRACT]: 'ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ',
}; 